import { ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Hidden from '@mui/material/Hidden';
import Toolbar from '@mui/material/Toolbar';
import clsx from 'clsx';
import NavbarToggleButton from './NavbarToggleButton';
import { toolbarTheme } from '../styles/defaultTheme';
import UserMenu from './UserMenu';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useCompanyCore } from '../../core/modules/company';
import { Company } from '../../core/interfaces/company.interface';
import { useMeCore } from '../../core/modules/me';
import { useEffect } from 'react';

interface Props {
  className: string;
}

const ToolbarLayout = (props: Props) => {
  const { companies, companyId, setCompanyId } = useCompanyCore();
  const { user } = useMeCore();

  // Seleccionar automáticamente la primera empresa si no hay ninguna seleccionada
  useEffect(() => {
    if (companies.length > 0 && (!companyId || !companies.some(c => c.id === companyId))) {
      setCompanyId(companies[0].id);
    }
  }, [companies, companyId, setCompanyId]);

  return (
    <ThemeProvider theme={toolbarTheme}>
      <AppBar
        id="fuse-toolbar"
        className={clsx('flex relative z-20 shadow-md', props.className)}
        color="default"
        sx={{
          backgroundColor: toolbarTheme.palette.background.paper,
        }}
        position="static"
      >
        <Toolbar className="p-0 min-h-48 md:min-h-64">
          <div className="flex flex-1 px-16">
            <Hidden lgUp>
              <NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
            </Hidden>
          </div>

          {user?.privileges.superAdmin && (
            companies.length > 0 ? (
              <FormControl sx={{ minWidth: 120 }} size="small">
                <InputLabel id="company-label"></InputLabel>
                <Select
                  id="select-company"
                  labelId="company-label"
                  value={companyId}
                  size="small"
                  onChange={(ev) => {
                    if (ev.target.value) {
                      setCompanyId(+ev.target.value);
                    }
                  }}
                >
                  {companies.map((company: Company) => (
                    <MenuItem key={company.id} value={company.id}>{company.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : null
          )}

          <div className="flex items-center px-8 h-full overflow-x-auto">
            <UserMenu />
          </div>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
};

export default ToolbarLayout;
